<script>

import Select from '../field-types/Select.vue';

export default {
  name: 'TablaMaestraSelect',
  extends: Select,
  created() {
    if (
      this.params
      && this.params.istablaMaestraSelect === 'true'
      && this.initialValue !== ''
    ) {
      this.initializeFromTablaMaestra();
    }
  },
  methods: {
    initializeFromTablaMaestra() {
      try {
        const initalVal = JSON.parse(this.initialValue);
        const initialAux = {
          item: Object.keys(initalVal.item)
            .filter((key) => !Number.isNaN(Number(key)))
            .map((key) => initalVal.item[key]),
        };
        const initial = initialAux.item;

        if (Array.isArray(initial)) {
          this.tablaMaestraData = initial;

          this.items = initial.map((it, idx) => ({
            label: it.texto || `Item ${idx + 1}`,
            value: it.id || it.id || idx,
          }));

          if (!this.value && this.items.length > 0) {
            this.value = this.items[0].value;
            this.$emit('update:inputData', {
              value: this.value,
              item: this.items[0],
            });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
